import React from 'react';
const Empty = () => (React.createElement("div", { style: { display: process.env.NODE_ENV === 'development' ? 'block' : 'none' } }, process.env.NODE_ENV === 'development' ? 'empty' : ''));
export default Empty;
